import React, { useState, useEffect } from "react";
import Sidebar from "./Sidebar";

import { ConfigProvider, Layout } from "antd";
import LayoutHeader from "./LayoutHeader";

const { Content } = Layout;

const MainLayout = (props) => {
  const [switchLabel, setSwitchLabel] = useState("Dark Mode");
  const [switchLabelColor, setSwitchLabelColor] = useState("#aeaeae");
  const [menuBG, setMenuBG] = useState("#000c18");
  const [searchColorBgContainer, setSearchColorBgContainer] =
    useState("#3B2639");
  const [menuTheme, setMenuTheme] = useState("dark");

  function onSwitchClick() {
    if (switchLabel === "Dark Mode") {
      setSwitchLabel("Light Mode");
      setMenuBG("#fff");
      setSearchColorBgContainer("#f7f8fa");
      setSwitchLabelColor("#8c8f9f");
      setMenuTheme("light");
    } else {
      setSwitchLabelColor("#aeaeae");
      setSwitchLabel("Dark Mode");
      setMenuBG("#000c18");
      setSearchColorBgContainer("#3B2639");
      setMenuTheme("dark");
    }
  }

  const {
    collapsed,
    // searchColorBgContainer,
    colorBgContainer,
    theme,
    defaultSelectedKeys,
    items,
    onClick,
    // switchLabel,
    // onSwitchClick,
    // switchLabelColor,
    logoDimensions,
    menuSearchBarState,
    menuSearchIconState,
    switchLabelState,
    setCollapsed,
    leftLayoutMargin,
    mode,
    children,
  } = props;
  return (
    <ConfigProvider
      theme={{
        components: {
          Layout: {
            siderBg: menuBG,
          },
          Menu: {
            darkItemBg: menuBG,
            darkSubMenuItemBg: "#241223",
          },
        },
      }}
    >
      <Layout style={{ height: "auto" }}>
        <Sidebar
          collapsed={collapsed}
          colorBgContainer={searchColorBgContainer}
          theme={menuTheme}
          defaultSelectedKeys={defaultSelectedKeys}
          items={items}
          onClick={onClick}
          switchLabel={switchLabel}
          onSwitchClick={onSwitchClick}
          switchLabelColor={switchLabelColor}
          logoDimensions={logoDimensions}
          menuSearchBarState={menuSearchBarState}
          menuSearchIconState={menuSearchIconState}
          switchLabelState={switchLabelState}
        />
        <Layout
          style={{
            marginLeft: leftLayoutMargin,
          }}
        >
          <LayoutHeader
            colorBgContainer={colorBgContainer}
            collapsed={collapsed}
            setCollapsed={setCollapsed}
          />
          <Content
            style={{
              margin: "25px 60px 25px 25px",
              padding: 24,
              minHeight: "calc(100vh - 112px)",
              height: "100%",
              // background: colorBgContainer,
              borderRadius: "20px",
            }}
          >
            {children}
          </Content>
        </Layout>
      </Layout>
    </ConfigProvider>
  );
};

export default MainLayout;
